// devExtreme
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

// utils
import { updateRemoteInit } from './updateRemoteInit';

// types
import {
  CustomStoreOpts,
  LoadStoreInitParams,
  PagingLoadOptions,
  PagingLoadSortOpt,
  GetPagingDataParams
} from './types';

const getSortWOKey = (key: string, sort?: PagingLoadSortOpt[]) => {
  if (!sort) return [];

  return sort.filter((x) => x.selector !== key);
};

const getPagingData = ({
  loadOpts,
  key,
  modifySorting
}: GetPagingDataParams) => {
  const { take, skip, searchValue, sort } = loadOpts;

  let KtoraStrona = null;
  let IloscRekordow = null;

  const cleanSort = getSortWOKey(key, sort);

  const Sortowanie = modifySorting ? modifySorting(cleanSort) : undefined;

  if (typeof take !== 'undefined' && typeof skip !== 'undefined') {
    KtoraStrona = skip / take + 1;
    IloscRekordow = take;
  }

  return {
    KtoraStrona,
    IloscRekordow,
    TekstWyszukiwanie: searchValue || null,
    Sortowanie
  };
};

const loadStoreInit = <TGetParams, TResData, TModifiedData>({
  key,
  fetchFn,
  getOptions,
  modifyDataOnSuccess,
  modifySorting
}: LoadStoreInitParams<TGetParams, TResData, TModifiedData>) => (
  loadOpts: PagingLoadOptions
) => {
  const pagingData = getPagingData({ key, loadOpts, modifySorting });

  return fetchFn({
    ...pagingData,
    ...getOptions
  }).then(({ data }) => ({
    data: modifyDataOnSuccess ? modifyDataOnSuccess(data.Dane) : data.Dane,
    totalCount: data.TotalCount
  }));
};

const customStore = <TGetParams, TResData, TModifiedData, TPatchResData>({
  key,
  dataGridRef,
  getOptions,
  get,
  modifyDataOnSuccess,
  modifySorting,
  patch,
  onPatchSuccess
}: CustomStoreOpts<TGetParams, TResData, TModifiedData, TPatchResData>) => {
  let updateFn;

  if (patch && dataGridRef) {
    const updateInitSetupData = {
      patchFn: patch,
      onPatchSuccess,
      dataGridRef,
      key
    };

    updateFn = updateRemoteInit<TPatchResData>(updateInitSetupData);
  }

  return new CustomStore({
    key,
    load: loadStoreInit<TGetParams, TResData, TModifiedData>({
      key,
      fetchFn: get,
      getOptions,
      modifySorting,
      modifyDataOnSuccess
    }),
    update: updateFn
  });
};

export const customDataSource = <
  TGetParams,
  TResData,
  TModifiedData = void,
  TPatchResData = void
>(
  customStoreOpts: CustomStoreOpts<
    TGetParams,
    TResData,
    TModifiedData,
    TPatchResData
  >
) =>
  new DataSource({
    store: customStore<TGetParams, TResData, TModifiedData, TPatchResData>(
      customStoreOpts
    )
  });
